module.exports = __webpack_public_path__ + "static/TangleTower1-44c024faa1cf7bbdf1e7129e528a1a45.webp";